import React from 'react';
import { GoogleAssetsEntities } from '../constants';
import { ImagesTab } from '../components/AssetsTabs/components/ImagesTab';
import { TextAssetsTab } from '../components/AssetsTabs/components/TextAssetsTab';

export type Tab = { label: string; component: JSX.Element; key: GoogleAssetsEntities };

export const DemandGenTabsDef: Tab[] = [
  { label: 'Image', key: GoogleAssetsEntities.IMAGES, component: <ImagesTab /> },
  { label: 'Headline', key: GoogleAssetsEntities.Headlines, component: <TextAssetsTab /> },
  { label: 'Description', key: GoogleAssetsEntities.Descriptions, component: <TextAssetsTab /> }
];

export const DisplayTabsDef: Tab[] = [
  { label: 'Image', key: GoogleAssetsEntities.IMAGES, component: <ImagesTab /> },
  { label: 'Short Headline', key: GoogleAssetsEntities.ShortHeadlines, component: <TextAssetsTab /> },
  { label: 'Long Headline', key: GoogleAssetsEntities.LongHeadlines, component: <TextAssetsTab /> },
  { label: 'Description', key: GoogleAssetsEntities.Descriptions, component: <TextAssetsTab /> }
];

export const DEFAULT_TAB = DemandGenTabsDef[0];
